"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImpactorSwarm = void 0;
const Tags_1 = require("../Tags");
const CardType_1 = require("../CardType");
const CardName_1 = require("../../CardName");
const RemoveAnyPlants_1 = require("../../deferredActions/RemoveAnyPlants");
const CardRequirements_1 = require("../CardRequirements");
const Card_1 = require("../Card");
const CardRenderer_1 = require("../render/CardRenderer");
class ImpactorSwarm extends Card_1.Card {
    constructor() {
        super({
            cost: 11,
            tags: [Tags_1.Tags.SPACE],
            name: CardName_1.CardName.IMPACTOR_SWARM,
            cardType: CardType_1.CardType.EVENT,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.tag(Tags_1.Tags.JOVIAN, 2)),
            metadata: {
                cardNumber: 'C16',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.heat(12).digit.br;
                    b.minus().plants(2).any;
                }),
                description: 'Requires 2 Jovian tags. Gain 12 heat. Remove up to 2 plants from any player.',
            },
        });
    }
    play(player) {
        player.game.defer(new RemoveAnyPlants_1.RemoveAnyPlants(player, 2));
        player.heat += 12;
        return undefined;
    }
}
exports.ImpactorSwarm = ImpactorSwarm;
//# sourceMappingURL=ImpactorSwarm.js.map